import { render, staticRenderFns } from "./blame_column_resizer.vue?vue&type=template&id=0b9eb681"
import script from "./blame_column_resizer.vue?vue&type=script&lang=js"
export * from "./blame_column_resizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports